<div class="row">
  <div
    class="col-3"
    baseTruncate
  >
    {{ provider?.customerLocation?.name | baseIsEmpty }}
  </div>

  <div class="col-4 d-flex align-items-center">
    <base-avatar
      [image]="provider?.logo?.data || ''"
      [size]="avatarSize.medium"
      [isCompany]="true"
    ></base-avatar>
    <div
      class="ms-3"
      baseTruncate
    >
      <span class="fw-bold">{{ provider?.pspBranchName | baseIsEmpty }}</span>
      <br />
      <span>{{ provider?.pspLegalName | baseIsEmpty }}</span>
    </div>
  </div>

  <div class="col-1">
    <i
      class="fa-solid"
      [class]="provider?.deliveryPriority + ' fa-circle-' + provider?.deliveryPriority"
      [ngbTooltip]="
        ('administration.timeToWait.timeToWaitCategory' | translate) +
        ' ' +
        (provider?.deliveryPriority?.toUpperCase() || '')
      "
    ></i>
  </div>

  <div class="col-3 col-md">
    <p
      class="m-0"
      baseTruncate
    >
      {{ provider?.address?.street | baseIsEmpty }}
    </p>
    <p
      class="m-0"
      baseTruncate
    >
      {{ (provider?.address?.postCode | baseIsEmpty) + ' ' + (provider?.address?.city | baseIsEmpty) }}
    </p>
  </div>

  <div class="col-1 col-md-auto">
    <base-izs-rating
      [color]="provider?.izsStatus"
      (click)="onIZSInfoOpen($event)"
    ></base-izs-rating>
  </div>
</div>
